export default __webpack_public_path__ + "media/JiraIntegration.a217bf7aefe01601a223694d0135be9f.svg";